import { render, staticRenderFns } from "./AbkSkillsList.vue?vue&type=template&id=1d327fe6&scoped=true&"
import script from "./AbkSkillsList.vue?vue&type=script&lang=js&"
export * from "./AbkSkillsList.vue?vue&type=script&lang=js&"
import style0 from "./AbkSkillsList.vue?vue&type=style&index=0&id=1d327fe6&scoped=true&lang=scss&"
import style1 from "./AbkSkillsList.vue?vue&type=style&index=1&id=1d327fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d327fe6",
  null
  
)

export default component.exports